import { loadable } from '@shared/core/loadableFromNamedExport';

export const AddCashFundDialogLegacyLazy = loadable(() => import('./AddCashFundDialogLegacy'), 'AddCashFundDialogLegacy');
